import { InstructorAdminApiFactory } from '@eloomi/eloomi-event-management-persona-client/1.0';
import { authorizeClient } from '@/api/authorize-client';

const instructorsClient = authorizeClient(InstructorAdminApiFactory);

export function getInstructors() {
    return instructorsClient.getInstructors().then(({ data }) => data);
}
